import { h, render } from 'preact';

import debounce from './utils/debounce';
import loadDisqus from './utils/load-disqus';
import {gVars} from './00-global-init.js';
import {addBarElements} from './00-global-functions.js';
import {addSVG} from './01-map-load-data.js';
import objectFitImages from 'object-fit-images';
import ScrollObserver from './utils/scroll-observer';
import select from './utils/select';

import RelatedContent from './components/RelatedContent';

const debouncedaddAllSVGs = debounce(
  addAllSVGs,
  300
);

var prev_resize_width = window.innerWidth;
var new_resize_width = window.innerWidth;
var mini_width = 200;

// Don't do resize event on mobile because it's called too often
window.addEventListener('resize', function() {
  // addAllSVGs();
  new_resize_width = window.innerWidth;

  if (prev_resize_width < gVars.mobile_width && new_resize_width < gVars.mobile_width) {
    mini_width = 215;
  } else {
    mini_width = 200;
  }

  // console.log('---');
  // console.log('mobile: ' + gVars.mobile_width);
  // console.log('prev: ' + prev_resize_width);
  // console.log('new: ' + new_resize_width);

  // Don't resize if we're moving from desktop to desktop
  if (prev_resize_width > gVars.mobile_width && new_resize_width > gVars.mobile_width) {
    // console.log('desktop > desktop');
  // Or mobile to mobile
  } else if (prev_resize_width < gVars.mobile_width && new_resize_width < gVars.mobile_width) {
    // console.log('mobile > mobile');
  } else {
    // console.log('ELSE');
    debouncedaddAllSVGs();
  }

  gVars.width_mini = mini_width;
  gVars.height_mini = Math.round(mini_width * 0.97);

  prev_resize_width = window.innerWidth;
});

window.addEventListener(
  'orientationchange',
  addAllSVGs
);

// Load them maps
function addAllSVGs() {
  addSVG(gVars.map_key);
  addSVG(gVars.map_vtds);
  addSVG(gVars.map_redistricting);
  addSVG(gVars.map_farenthold_home);
  addSVG(gVars.map_hispanic);
  addSVG(gVars.map_hod);
  addSVG(gVars.map_hod_zoom);
}

addAllSVGs();
addBarElements();

// Set height of toggle container
// Based on the height of the first container
// This assumes the first container is the tallest
if (window.innerWidth > 750) {
  var toggle_containers = document.querySelectorAll('.toggle-prose-container');

  for (var x = 0; x < toggle_containers.length; x++) {
    var c_container = toggle_containers[x];
    var height = c_container.offsetHeight;

    document.querySelectorAll('.toggle-prose-container')[x].style.height = height + 'px';
  }
}

const commentsContainer = select('.container--comments');
const activateComments = select('#activate-comments');
const disqusThread = select('#disqus_thread');
const COMMENT_LOAD_THRESHOLD = 500;

const whenScroll = new ScrollObserver();

// load disqus when close
const disqusScrollWatcher = whenScroll.add(() => {
  const rect = commentsContainer.getBoundingClientRect();
  const clientHeight = document.documentElement.clientHeight;

  if (rect.top <= clientHeight + COMMENT_LOAD_THRESHOLD) {
    loadDisqus(() => {
      disqusScrollWatcher.remove();
    });
  }
});

activateComments.addEventListener('click', () => {
  commentsContainer.classList.add('container--comments-loading');

  loadDisqus(() => {
    disqusThread.scrollIntoView();
    disqusScrollWatcher.remove();
  });
});

/*
Kickstart the scroll watcher in case it's reloaded in the middle of the page
 */
whenScroll.onScroll();

if (select('.dv-gpt-ad') != null) {
  import(/* webpackChunkName: "adloader" */ './utils/ad-loader').then(
    module => {
      const AdLoader = module.default;

      const loader = new AdLoader({
        targetingKey: 'guten',
        targetingValue: process.env.primary_guten_tag,
      });
      loader.init();
    }
  );
}

render(
  <RelatedContent title="More Lock the Vote stories" />,
  select('#related-content-container')
);

export default () => {
  import(/* webpackChunkName: "analytics" */ '@data-visuals/analytics').then(
    analytics => analytics.init()
  );
};



// WEBPACK FOOTER //
// ./main.js